import React from "react";
import styles from './navbar.module.css';
import { NavLink } from "react-router-dom";

function Navbar({
  logedIn
}) {

  return(
    <nav className={`${styles.navbar}`}>
      <NavLink to='/' className={({ isActive }) => isActive ? `${styles.link_first__active}` : `${styles.link_first}`}>
        Главная
      </NavLink>
      <NavLink to='/catalog' className={({ isActive }) => isActive ? `${styles.link__active}` : `${styles.link}`}>
        Каталог
      </NavLink>
      <NavLink to='/news' className={({ isActive }) => isActive ? `${styles.link__active}` : `${styles.link}`}>
        Новости
      </NavLink>
      <NavLink to='/docs' className={({ isActive }) => isActive ? `${styles.link__active}` : `${styles.link}`}>
        Документация
      </NavLink>
      <NavLink to='/about' className={({ isActive }) => isActive ? `${styles.link__active}` : `${styles.link}`}>
        О нас
      </NavLink>
      <NavLink to='/pay' className={({ isActive }) => isActive ? `${styles.link__active}` : `${styles.link}`}>
        Оплата
      </NavLink>
      <NavLink to='/delivery' className={({ isActive }) => isActive ? `${styles.link__active}` : `${styles.link}`}>
        Доставка
      </NavLink>
    </nav>
  );
}

export default Navbar;
